export default {
  welcome: {
    title: "Welcome to Tabbio",
    body: "Take a quick tour through chat, CV, job search, Automation, and skills.",
    primaryCta: "Show me",
    skipCta: "Skip tour",
  },
  chat: {
    title: "Ask Tabbio",
    body: "Start with one career task in chat. Tabbio plans the next step and asks before sending anything.",
    primaryCta: "Got it",
  },
  drawerIcon: {
    title: "Open the menu",
    body: "Tap here anytime for your CVs, jobs, tasks, skills, and settings.",
    primaryCta: "Got it",
  },
  drawerItems: {
    title: "Get around quickly",
    chat: "Start a new conversation with Tabbio anytime.",
    webcv: "Build, edit, and review your main CV.",
    shared: "Open CVs shared with you and review direct access.",
    analytics: "Track CV views and application activity from one place.",
    jobs: "Find matching roles and continue applications.",
    automatch: "Let Automation monitor opportunities and queue strong fits for review.",
    skills: "Add curated skills that strengthen your CV and matches.",
    notifications: "Job matches, application updates, and alerts land here.",
    settings: "Preferences, language, and account.",
  },
  settings: {
    replayLabel: "Show product tour",
    replayDescription: "Walk through the app again",
  },
};
